import React, { useState } from "react";
import { compose } from "redux";
import axios from "axios";
import { gql } from "apollo-boost";
import Dropdown from "react-dropdown";
import { connect } from "react-redux";
import { Text, InputContainer, TextArea, withQuery } from "components/common";
import checkCircle from "assets/check-circle.svg";
import errorCircle from "assets/error-circle.svg";
import { track } from "utils/analytics";
import { CUSTOMER_SERVICE_OPTIONS } from "../Support/consts";

const options = [
  "Spending power too low",
  "Autopay is too frequent",
  "Poor customer service",
  "I don’t really need the card",
  "I don’t like the rewards",
  "Other"
];

const Terminate = ({
  userId,
  data: { user: { first_name, last_name, email, phone_number: phone } = {} }
}) => {
  track("DASHBOARD_TERMINATION_PAGE_LOADED");
  const [reason, setReason] = useState(null);
  const [description, setDescription] = useState("");
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const reset = () => {
    setReason(null);
    setDescription("");
  };

  const handleSubmit = async () =>
    axios
      .post("/terminationRequest", {
        name: `${first_name} ${last_name}`,
        subject: `Card Termination Request - ${reason || "No Reason Provided"}`,
        description,
        email: userId || email,
        phone
      })
      .then(() => {
        setError(null);
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
        reset();
      })
      .catch(err => {
        console.log("error sending support email", err);
        setError(err);
      });

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <form className="flex-1">
          <Text className="mb-4 font-bold">Terminate Your Card</Text>
          {success && (
            <div className="flex mb-2 items-center">
              <img
                alt="success"
                className="mr-1"
                style={{ height: "20px" }}
                src={checkCircle}
              />
              <p className="text-green-primary mr-px">Success. </p>
              <p className="">Your submission has been sent.</p>
            </div>
          )}
          {error && (
            <div className="flex items-center mb-2">
              <img
                alt="success"
                className="mr-1"
                style={{ height: "20px" }}
                src={errorCircle}
              />
              <p className="text-red-400">
                There was an issue with your request. Please try again.
              </p>
            </div>
          )}

          <InputContainer
            className="bg-white cursor-pointer mb-2"
            style={{
              border: "none",
              boxShadow: "0 2px 4px 0 rgba(30, 61, 63, .06)",
              padding: 0
            }}
          >
            <Dropdown
              className="w-full cursor-pointer"
              controlClassName="border-none cursor-pointer px-4"
              menuClassName="Dropdown-shadow"
              options={options}
              onChange={e => setReason(e.value)}
              value={reason}
              placeholder="Termination Reason"
            />
          </InputContainer>
          <InputContainer
            className="bg-white mb-2"
            style={{
              border: "none",
              boxShadow: "0 2px 4px 0 rgba(30, 61, 63, .06)",
              height: "180px"
            }}
          >
            <TextArea
              placeholder="Please explain"
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </InputContainer>
        </form>
        <button
          type="button"
          className="btn btn-green px-16 mt-2 md:hidden"
          onClick={handleSubmit}
          disabled={!reason || !description}
        >
          Submit
        </button>
        <div
          className="mt-8 md:pl-8 md:ml-8 md:border-l md:mt-0"
          style={{ minWidth: "300px", maxWidth: "400px" }}
        >
          <Text className="mb-6 font-bold">
            You can always reach out to us!
          </Text>
          <div className="mb-6">
            <Text>
              Card termination is permanent. Closing accounts can affect your
              credit score.
            </Text>
          </div>
          <div>
            {CUSTOMER_SERVICE_OPTIONS.map(({ type, content }) => (
              <div className="flex">
                <Text className="pr-1 capitalize font-bold">{`${type}: `}</Text>
                <Text className="">{content}</Text>
              </div>
            ))}
          </div>

          <div className="pt-6 block md:hidden text-sm">
            <text>
              <a
                href="https://tomocredit.com/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                Privacy Policy
              </a>
              <span className="mr-2 ml-2">|</span>
              <a
                href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/TermsOfUse.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                Terms of Use
              </a>
            </text>
          </div>
        </div>
      </div>
      <button
        type="button"
        className="hidden md:block btn btn-green px-16 mt-2"
        onClick={handleSubmit}
        disabled={!reason || !description}
      >
        Submit Request
      </button>
    </>
  );
};

const SUPPORT_QUERY = gql`
  query Terminate {
    user {
      first_name
      last_name
      email
      phone_number
    }
  }
`;

export default compose(
  connect(state => ({
    userId: state.user.id
  })),
  withQuery(SUPPORT_QUERY)
)(Terminate);
